<div class="mobile-menus-screen">
    <!-- <h3><i class="mdi mdi-account-circle"></i> {{user.username}} <span class="time-zone">GMT+5:30</span></h3> -->
    <h3>
        <i class="mdi mdi-account-circle"></i> {{user.username}}
        <div class="dark-light-button">
            <input type="checkbox" name="checkbox-123" [(ngModel)]="env.darkMode" (change)="toogleBody()">
        </div>
        <span class="time-zone">GMT+5:30</span>
    </h3>
    <ul>
        <li><a href="javascript:void(0)" routerLink="/profile">my profile</a></li>
        <!-- <li><a href="javascript:void(0)" routerLink="/reports/account-statement">rolling commission</a></li> -->
        <li><a href="javascript:void(0)" routerLink="/reports/account-statement">account statement</a></li>
        <li><a href="javascript:void(0)" routerLink="/my-bets">Unsettled Bets</a></li>
        <li><a href="javascript:void(0)" routerLink="/reports/profit-loss">profit/loss</a></li>
        <li><a href="javascript:void(0)" (click)="settingModal.show()">stake setting</a></li>
        <li><a href="javascript:void(0)" routerLink="/market-analysis">Market Analysis</a></li>
        <li><a href="javascript:void(0)" routerLink="/change-password">Change Password</a></li>
        <!-- <li><a href="javascript:void(0)" routerLink="/reports/summary">active log</a></li> -->
    </ul>
    <a href="javascript:void(0)" (click)="logOut()" class="mbl-logout-btn">LOGOUT <i
            class="mdi mdi-login-variant"></i></a>
</div>


<!-- mobile stake modal -->
<div id="MobileStake" class="modal fade" bsModal #settingModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
    role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title" id="MobileStakeLabel"><i class="mdi mdi-cog"></i> &nbsp; Setting</h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="settingModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <!-- <div class="modal-body"> -->
            <app-stakes (close)="settingModal.hide()"></app-stakes>
            <app-loader class="full-overlay" *ngIf="isLoading"></app-loader>
            <!-- </div> -->
        </div>
    </div>
</div>
<!-- mobile stake modal -->